import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { albanyOrConfig } from "./data";

export default function AlbanyOrPage() {
  return <OregonCityPageTemplate config={albanyOrConfig} />;
}